import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Container } from "@mui/system";
import {
  Paper,
  Grid,
  Typography,
  TextField,
  MenuItem,
  Button,
  CircularProgress,
  Box,
} from "@mui/material";
import NumberFormat from "react-number-format";
import PropTypes from "prop-types";
import Page from "../components/Page";
import Modal from "../components/Modal";

//Hooks
import { useFirestore } from "../hooks/useFirestore";
import { useDocument } from "../hooks/useDocument";

const NumberFormatCustom = React.forwardRef(function NumberFormatCustom(
  props,
  ref
) {
  const { onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={ref}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      thousandSeparator
      isNumericString
      suffix="%"
    />
  );
});

NumberFormatCustom.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

const NumberFormatCustom1 = React.forwardRef(function NumberFormatCustom1(
  props,
  ref
) {
  const { onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={ref}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      thousandSeparator
      isNumericString
      //   suffix="%"
    />
  );
});

NumberFormatCustom1.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

function SalesForm() {
  const [name, setName] = useState("");
  const [craneModel, setCraneModel] = useState("");
  const [craneNo, setCraneNo] = useState("");
  const [jobDesc, setJobDesc] = useState("");
  const [quote, setQuote] = useState("");
  const [price, setPrice] = useState("");
  const [currency, setCurrency] = useState("");
  const [date, setDate] = useState("");
  const [valueOfQuote, setValueOfQuote] = useState("");
  const [akolisaQuote, setAkolisaQuote] = useState("");
  const [year, setYear] = useState("");
  const [month, setMonth] = useState("");
  const [supplier, SetSupplier] = useState("");
  const [status, setStatus] = useState("");
  const [origin, setOrigin] = useState("");
  const [remark, setRemark] = useState("");

  const { document } = useDocument("Sale");
  const { addDocument, updateDocument, message, isError, isPending } =
    useFirestore("Sale");
  const { id } = useParams();
  useEffect(() => {
    const detail = async () => {
      try {
        const docSnap = await document(id);
        // console.log(docSnap.data())
        setName(docSnap.data().name);
        setCraneModel(docSnap.data().craneModel);
        setCraneNo(docSnap.data().craneNo);
        setJobDesc(docSnap.data().jobDesc);
        setCurrency(docSnap.data().currency);
        setQuote(docSnap.data().quote);
        setPrice(docSnap.data().price);
        setDate(docSnap.data().date);
        setAkolisaQuote(docSnap.data().akolisaQuote);
        setYear(docSnap.data().year);
        SetSupplier(docSnap.data().supplier);
        setMonth(docSnap.data().month);
        setStatus(docSnap.data().status);
        setOrigin(docSnap.data().origin);
        setRemark(docSnap.data().remark);
        setValueOfQuote(docSnap.data().valueOfQuote);
      } catch (error) {
        // console.log(error)
      }
    };
    if ((id !== undefined || id !== "") && id !== ":id") {
      detail();
    }

    // eslint-disable-next-line
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const inventory = {
      name,
      jobDesc,
      craneNo,
      craneModel,
      quote,
      currency,
      akolisaQuote,
      supplier,
      year,
      month,
      status,
      date,
      price,
      origin,
      valueOfQuote,
    };
    try {
      if ((id !== undefined || id !== "") && id !== ":id") {
        await updateDocument(id, inventory);
      } else {
        await addDocument(inventory);
      }
    } catch (error) {
      // console.log('msg', error.message)
    }
  };
  const navigate = useNavigate();
  useEffect(() => {
    if (message) {
      setOpen(true);
      setTimeout(() => {
        navigate("/dashboard/sales", {
          replace: true,
        });
      }, 2000);
    }
  }, [message, navigate]);

  const [open, setOpen] = useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Page title="Service Form">
      <Container maxWidth="xl">
        <Box component="form" onSubmit={handleSubmit}>
          <Paper elevation={6} sx={{ p: 6 }}>
            <Grid
              container
              spacing={3}
              sx={{ justifyContent: "space-between", marginBottom: 1 }}
            >
              <Grid item xs={12} sm={6} md={6}>
                <Typography variant="h4" sx={{ mb: 1 }}>
                  Sales Form
                </Typography>
              </Grid>
            </Grid>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6} md={4} lg={4}>
                <Typography variant="body2">CustomerName</Typography>
                <TextField
                  size="small"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={4}>
                <Typography variant="body2">Crane SN</Typography>
                <TextField
                  size="small"
                  value={craneNo}
                  onChange={(e) => setCraneNo(e.target.value)}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={4}>
                <Typography variant="body2">Crane Model</Typography>
                <TextField
                  size="small"
                  value={craneModel}
                  onChange={(e) => setCraneModel(e.target.value)}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={4}>
                <Typography variant="body2">Job Desc</Typography>
                <TextField
                  size="small"
                  value={jobDesc}
                  onChange={(e) => setJobDesc(e.target.value)}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={4}>
                <Typography variant="body2">Prices</Typography>
                <TextField
                  size="small"
                  value={price}
                  onChange={(e) => setPrice(e.target.value)}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={4}>
                <Typography variant="body2">Date</Typography>
                <TextField
                  size="small"
                  type="date"
                  value={date}
                  onChange={(e) => setDate(e.target.value)}
                  fullWidth
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4} lg={4}>
                <Typography variant="body2">Akolisa Quote No</Typography>
                <TextField
                  size="small"
                  value={akolisaQuote}
                  onChange={(e) => setAkolisaQuote(e.target.value)}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={4}>
                <Typography variant="body2">Value of Akolisa Quote</Typography>
                <TextField
                  size="small"
                  value={valueOfQuote}
                  onChange={(e) => setValueOfQuote(e.target.value)}
                  name="numberformat"
                  InputProps={{
                    inputComponent: NumberFormatCustom1,
                  }}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={4}>
                <Typography variant="body2">Year Of Quote</Typography>
                <TextField
                  size="small"
                  value={year}
                  onChange={(e) => setYear(e.target.value)}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={4}>
                <Typography variant="body2">Month Of Quote</Typography>
                <TextField
                  size="small"
                  value={month}
                  onChange={(e) => setMonth(e.target.value)}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={4}>
                <Typography variant="body2">Supplier</Typography>
                <TextField
                  size="small"
                  value={supplier}
                  onChange={(e) => SetSupplier(e.target.value)}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={4}>
                <Typography variant="body2">Currency</Typography>
                <TextField
                  size="small"
                  id="select"
                  select
                  value={currency}
                  onChange={(e) => setCurrency(e.target.value)}
                  fullWidth
                >
                  <MenuItem value="$">Dollar $</MenuItem>
                  <MenuItem value="£">Pounds £</MenuItem>
                  <MenuItem value="€">Euro €</MenuItem>
                  <MenuItem value="₦">Naira ₦</MenuItem>
                </TextField>
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={4}>
                <Typography variant="body2">Quote</Typography>
                <TextField
                  size="small"
                  value={quote}
                  onChange={(e) => setQuote(e.target.value)}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={4}>
                <Typography variant="body2">Status</Typography>
                <TextField
                  size="small"
                  value={status}
                  onChange={(e) => setStatus(e.target.value)}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={4}>
                <Typography variant="body2">Origin Of Leads</Typography>
                <TextField
                  size="small"
                  value={origin}
                  onChange={(e) => setOrigin(e.target.value)}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={4}>
                <Typography variant="body2">Remark</Typography>
                <TextField
                  size="small"
                  value={remark}
                  onChange={(e) => setRemark(e.target.value)}
                  fullWidth
                />
              </Grid>
            </Grid>

            <Box mt={2} width="100%" display="flex" justifyContent="right">
              {!isPending && (
                <Button
                  type="submit"
                  variant="contained"
                  sx={{ color: "#fff", mt: 2 }}
                >
                  Submit Report
                </Button>
              )}

              {isPending && (
                <Button
                  variant="contained"
                  sx={{ pr: 5, pl: 5, backgroundColor: "#fff" }}
                >
                  <CircularProgress size={25} />
                </Button>
              )}
            </Box>
          </Paper>
        </Box>
      </Container>
      {message && (
        <Modal
          handleClickOpen={handleClickOpen}
          open={open}
          handleClose={handleClose}
          message={message}
          type={"Success"}
        />
      )}
      {isError && (
        <Modal
          handleClickOpen={handleClickOpen}
          open={open}
          handleClose={handleClose}
          message={isError}
          type={"Error"}
        />
      )}
    </Page>
  );
}

export default SalesForm;
